import { render, staticRenderFns } from "./ReportHumanResource.vue?vue&type=template&id=634c6028"
import script from "./ReportHumanResource.vue?vue&type=script&lang=js"
export * from "./ReportHumanResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports